/* eslint-disable react/jsx-no-undef */
import React, { useState, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Row,
  Col,
  Form,
  DatePicker,
  Slider,
  Button,
  Typography,
  Input,
  Select,
  ConfigProvider,
  Checkbox,
} from 'antd';
import moment from 'moment';
import { SliderValue } from 'antd/lib/slider';
import { FaCaretDown } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import {
  RestrictionsMenu,
  RestrictionContext,
} from '../dashboard/components/Restrictions';
import { Consumption } from '../dashboard/Filter';
import { Category } from '../meals/components/ProductCategory';
import { PageHeader } from '../layout/PageHeader';
import { setFilterData } from '../../store/user/actions';

import { useHistory } from 'react-router-dom';
import CZ from 'antd/lib/locale-provider/cs_CZ';
import IT from 'antd/lib/locale-provider/it_IT';
import EN from 'antd/lib/locale-provider/en_US';
import 'moment/locale/cs';
import 'moment/locale/it';

const { Option } = Select;

export interface Time {
  id: number;
  title: string;
  active: boolean;
  time: string;
}

export interface ScheduleProps {
  date?: Date;
  time?: string[];
}

export interface TimeProps {
  day?: Date;
  done: (date: Date | undefined, time: string[]) => void;
}

export interface TimeScheduleContextProps {
  time: Time[];
}

export interface DateSelectionProps {
  scheduleValues: ScheduleProps[] | undefined;
  onClick: (schedule: ScheduleProps[] | undefined) => void;
}

export const FilterForm: React.FC = () => {
  const [isloading, setLoading] = useState(false);
  const [width, setWidth] = useState<number>(0);
  const [restrictionValues, setRestrictionValues] = useState<string[]>([]);
  const [price, setSliderPriceValue] = useState<number | [number, number]>(1);
  const [sliderDistanceValue, setSliderDistanceValue] = useState<
    number | [number, number]
  >(0);
  const { restriction } = React.useContext(RestrictionContext);
  const [category, setCategory] = useState<string[]>([]);
  const [consumption, setConsumption] = useState();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [isChecked, setCheckStable] = useState<boolean>(false);
  const [locationValue, setLocationValue] = useState('nearest');
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const history = useHistory();
  const dateTimeFormat = `ddd, MMM D, YYYY, h:mm a`;

  const handleValueChange = (value: any) => {
    setLocationValue(value);
  };
  const onFromDateChange = (value: any, dateString: string) => {
    setFromDate(dateString);
  };

  const onToDateChange = (value: any, dateString: string) => {
    setToDate(dateString);
  };

  const onSliderValueChange = (e: SliderValue) => {
    setSliderPriceValue(e);
  };

  const onSliderDistanceValueChange = (e: SliderValue) => {
    setSliderDistanceValue(e);
  };

  const handleRestrictionContextChange = () => {
    const getRestrictionValues = restriction.filter(i => i.checked);
    setRestrictionValues(getRestrictionValues.map(v => v.title));
  };

  // const handleStableOffer = () => {
  //   setCheckStable(!isChecked);
  // };

  const onFormFinish = (values: any): void => {
    setLoading(true);
    const dates = {
      from: fromDate === undefined ? '' : moment(fromDate).format('YYYY/MM/DD'),
      to: toDate === undefined ? '' : moment(toDate).format('YYYY/MM/DD'),
    };
    const filterData = {
      isFilter: true,
      distance: Number(sliderDistanceValue),
      // consumption: consumption === undefined ? '' : consumption,
      // price,
      category,
      restrictions: restrictionValues,
      selectedDate: dates,
      constantOffer: isChecked,
      keyword: values.keyword ? values.keyword : '',
    };
    setTimeout(() => {
      dispatch(setFilterData(filterData));
      setLoading(false);
      history.goBack();
    }, 2000);
  };

  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  const isDesktop = width >= 900;
  return (
    <RestrictionContext.Provider
      value={{
        restriction,
        category: category,
        setCategory,
        handleRestrictionContextChange,
      }}
    >
      <div className="profile-container">
        <PageHeader headerTitle="Filter" />
        <Row justify="center" className="add-meals-container">
          <Col
            xs={24}
            sm={24}
            md={14}
            lg={10}
            xl={10}
            className="create-meals-wrapper"
          >
            <Form
              size="middle"
              name="create-meals"
              layout="vertical"
              onFinish={onFormFinish}
              form={form}
            >
              {!isDesktop && (
                <Form.Item name="keyword">
                  <Col style={{ marginTop: 10 }}>
                    <Input placeholder={t('SEARCH_FOR')} />
                  </Col>
                </Form.Item>
              )}

              <React.Fragment>
                <Row className="location-filter-container">
                  <Typography.Text className="filter-menu-title">
                    {t('LOCATION')}
                  </Typography.Text>
                  <Select
                    defaultValue="nearest"
                    suffixIcon={<FaCaretDown />}
                    style={{ borderRadius: 32 }}
                    className="filter-loc-menu"
                    onChange={handleValueChange}
                  >
                    <Option value="nearest">{t('NEAREST')}</Option>
                    <Option value="set">{t('SET')}</Option>
                  </Select>
                </Row>
                {locationValue === 'set' && (
                  <div>
                    <span className="form-label">MAX DISTANCE</span>
                    <span className="form-label-extra">{`${sliderDistanceValue} km`}</span>
                    <Slider
                      min={1}
                      step={1}
                      onChange={onSliderDistanceValueChange}
                    />
                  </div>
                )}
              </React.Fragment>
              {/* </Form.Item> */}
              <Form.Item>
                <Category />
              </Form.Item>
              <RestrictionsMenu />
              <Form.Item>
                <Row className="location-filter-container">
                  <Typography.Text className="filter-menu-title">
                    {t('Date and Time')}
                  </Typography.Text>
                  <Input.Group className="filter-buttons filter-restrictions-menu filter-input-group">
                    <span>{t('FROM')}</span>
                    <ConfigProvider
                      locale={
                        i18n.language === 'cz'
                          ? CZ
                          : i18n.language === 'it'
                          ? IT
                          : EN
                      }
                    >
                      <DatePicker
                        showTime
                        style={{ width: '100%' }}
                        format={dateTimeFormat}
                        onChange={onFromDateChange}
                        // onOk={onFromDateOk}
                      />
                    </ConfigProvider>
                  </Input.Group>
                  <Input.Group className="filter-buttons filter-restrictions-menu filter-input-group">
                    <span>{t('TO')}</span>
                    <ConfigProvider
                      locale={
                        i18n.language === 'cz'
                          ? CZ
                          : i18n.language === 'it'
                          ? IT
                          : EN
                      }
                    >
                      <DatePicker
                        showTime
                        style={{ width: '100%' }}
                        format={dateTimeFormat}
                        onChange={onToDateChange}
                        // onOk={onToDateOk}
                      />
                    </ConfigProvider>
                  </Input.Group>
                </Row>
              </Form.Item>
              {/* <Form.Item>
                <Checkbox checked={isChecked} onClick={handleStableOffer}>
                  <span
                    style={{
                      fontWeight: 'bold',
                      fontSize: '15px',
                      color: '#000',
                    }}
                  >
                    {' '}
                    {t('CONSTANT_OFFER')}
                  </span>
                </Checkbox>
              </Form.Item> */}
              {/* <Form.Item>
                <Consumption setConsumption={setConsumption} />
              </Form.Item>
              <Form.Item>
                <React.Fragment>
                  <div>
                    <span className="form-label">{t('MAX_PRICE')}</span>
                    <span className="form-label-extra">{`${price} Kč`}</span>
                    <Slider
                      min={1}
                      max={10000}
                      step={1}
                      onChange={onSliderValueChange}
                    />
                  </div>
                </React.Fragment>
              </Form.Item> */}
              <Form.Item className="form-buttons-container">
                <div className="primary-button-basic-container">
                  <Button
                    shape="round"
                    className="primary-button-basic"
                    htmlType="submit"
                    // disabled={disabled}
                    loading={isloading}
                  >
                    {isloading ? 'Saving Filter' : t('Save')}
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    </RestrictionContext.Provider>
  );
};
